import script from "./InspecaoSupervisaoEstabelecimentoEmissaoB.vue?vue&type=script&setup=true&lang=js"
export * from "./InspecaoSupervisaoEstabelecimentoEmissaoB.vue?vue&type=script&setup=true&lang=js"

import "./InspecaoSupervisaoEstabelecimentoEmissaoB.vue?vue&type=style&index=0&id=5058ee79&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5058ee79"]])

export default __exports__